// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".railNav[data-v-ff2df984]{position:fixed;z-index:1;top:7rem;left:0;background:transparent!important;-webkit-transform:translateX(-50%);transform:translateX(-50%);-webkit-transition:margin-top 1s;transition:margin-top 1s;margin-top:30vh}body[data-scrolltop=on] .railNav[data-v-ff2df984]{margin-top:0}@media only screen and (max-width:956px){.railNav[data-v-ff2df984]{display:none}}", ""]);
// Exports
module.exports = exports;
